module.exports = __webpack_public_path__ + "static/img/1627013129838689.a08a4b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/1627013129838689.jpg
// module id = 3Qoq
// module chunks = 1